module.exports = __webpack_public_path__ + "static/HighFiveGif-5b548a8b9557996105683bf9d9c0d014.gif";